// src/pages/NavDetails/productDetails.jsx
import React, { useEffect, useRef } from "react";
import TermsAndPolicyFooter from "../../components/common/PrivacyPolicy/CompanyTermsAndPolicy/TermsAndPolicyFooter";
import hero from "../../assets/images/products_hero.svg";
// import question_generator from "../../assets/images/question_generator.jpg";
// import convertational_score from "../../assets/images/convertational_score.jpg";
// import analytics from "../../assets/images/analytics.jpg";
// import export_integration from "../../assets/images/export_integration.jpg";
import steps_img from "../../assets/images/Step1.png";
import { useNavigate } from "react-router-dom";
import {faqs, simplify, carousel} from "./productData.js"

const ProductDetails = () => {
  const scrollRef = useRef(null);
  const animationRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollAmount = 0;
    const speed = 0.5;
    let isScrolling = true;

    const scroll = () => {
      if (!scrollContainer || !isScrolling) return;

      scrollAmount += speed;
      scrollContainer.scrollLeft = scrollAmount;

      if (scrollAmount >= scrollContainer.scrollWidth / 2) {
        scrollAmount = 0;
        scrollContainer.scrollLeft = 0;
      }

      animationRef.current = requestAnimationFrame(scroll);
    };

    scroll();

    return () => {
      isScrolling = false;
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  const goToLogin = () => {
    navigate("/login_register");
  };

  return (
    <div>
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
      <div className="w-11/12 md:w-10/12 lg:w-9/12 mx-auto">

<div className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen flex flex-col md:flex-row items-center gap-10 py-20 px-6 md:px-16 border-b border-gray-200 overflow-hidden">


  {/* <div className="absolute -top-20 -left-20 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div> */}


  <div className="flex-1 text-center md:text-left space-y-6">
    <h1 className="text-4xl md:text-6xl font-extrabold leading-tight">
      End-to-End <br />
      <span className="bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
        Assessments
      </span>{" "}
      <br />
      Made Easy!
    </h1>

    <p className="text-gray-600 text-lg md:text-xl">
      Assessment creation, delivery & analytics —
      <span className="text-[#36369f] font-semibold"> all in one workspace.</span>
    </p>

    <button
      onClick={goToLogin}
      className="px-10 py-3 rounded-xl text-white font-semibold 
      bg-gradient-to-l from-indigo-950 to-indigo-800 
      hover:scale-105 transition-all duration-300 shadow-lg"
    >
      Start for Free
    </button>
  </div>


  <div className="flex-1 flex justify-center">
    <img src={hero} className="w-[90%] max-w-md animate-float" />
  </div>

</div>
        

  
<div className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen py-20 overflow-hidden">


  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-full px-6 md:px-12 lg:px-20">
    

    <div className="text-center mb-12">
      <p className="w-fit mx-auto px-6 py-2 uppercase text-xs font-semibold 
      bg-white/60 backdrop-blur-md rounded-full shadow text-gray-600">
        Simplify
      </p>

      <h3 className="text-3xl md:text-5xl font-extrabold mt-6 mb-4 
     bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
        Solutions To Your Problems
      </h3>

      <p className="text-gray-600 max-w-2xl mx-auto">
        Bring your entire assessment process together — seamlessly managed
        in one powerful platform.
      </p>
    </div>


    <div className="flex flex-col lg:flex-row gap-12 items-center">

   
      <div className="lg:w-4/12 w-full space-y-6 text-center lg:text-left">
        <h2 className="text-3xl md:text-4xl font-extrabold">
          Assessment Chaos <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-l from-indigo-950 to-indigo-800">
            Slowing
          </span>{" "}
          You Down?
        </h2>

        <p className="text-gray-600 text-lg">
          Assessment tools often complicate what should be simple.  
          We’ve streamlined everything — so you can create, deliver, and analyze
          without friction.
        </p>
      </div>


      <div className="lg:w-8/12 w-full grid md:grid-cols-2 gap-6">


        <div className="space-y-4">
          <h5 className="font-bold text-red-600">Problem ❌</h5>

          {simplify.map((item, index) => (
            <div
              key={`problem-${index}`}
              className="bg-white/70 backdrop-blur-lg border border-red-100 
              p-4 rounded-xl shadow-sm hover:shadow-md transition"
            >
              {item.problem}
            </div>
          ))}
        </div>

   
        <div className="space-y-4">
          <h5 className="font-bold text-green-600">Solution ✔</h5>

          {simplify.map((item, index) => (
            <div
              key={`solution-${index}`}
              className="bg-white/70 backdrop-blur-lg border border-green-100 
              p-4 rounded-xl shadow-sm hover:shadow-md transition"
            >
              {item.solution}
            </div>
          ))}
        </div>

      </div>

    </div>

  </div>
</div>

<div className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen py-24 overflow-hidden">


  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-full px-6 md:px-12 lg:px-20">


    <div className="text-center mb-12">
      <p className="w-fit mx-auto px-6 py-2 uppercase text-xs font-semibold 
      bg-white/60 backdrop-blur-md rounded-full shadow text-gray-600">
        Features
      </p>

      <h3 className="text-3xl md:text-5xl font-extrabold mt-6 mb-4 
      bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
        Powerful Features, Minimal Effort
      </h3>

      <p className="text-gray-600 max-w-2xl mx-auto text-sm md:text-base">
        Create, deliver, and analyze assessments in one smooth workflow —
        powered by AI precision.
      </p>
    </div>


    <div className="relative w-full">

      <div
        ref={scrollRef}
        className="flex gap-6 py-6 overflow-x-auto no-scrollbar px-2"
      >
        {[...carousel, ...carousel].map((card, index) => (
          <div
            key={index}
            className="group flex-shrink-0 w-64 sm:w-72 md:w-80 lg:w-96 
            bg-white/70 backdrop-blur-lg border border-white/30 
            rounded-2xl p-4 shadow-md 
            hover:shadow-xl hover:-translate-y-2 transition-all duration-300"
          >

    
            <h3 className="text-base sm:text-lg font-semibold mb-3 text-gray-800">
              {card.title}
            </h3>

            <div className="overflow-hidden rounded-xl">
              <img
                src={card.img}
                alt={card.title}
                className="h-40 sm:h-48 md:h-52 w-full object-cover rounded-xl 
                group-hover:scale-105 transition duration-300"
              />
            </div>

   
            <p className="text-sm text-gray-600 mt-3 leading-relaxed">
              {card.desc}
            </p>

          </div>
        ))}
      </div>

    </div>

  </div>
</div>

      

<div className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen py-24 overflow-hidden">

  
  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

 
  <div className="w-full px-6 md:px-12 lg:px-20">


    <div className="text-center mb-16">
      <p className="w-fit mx-auto px-6 py-2 uppercase text-xs font-semibold 
      bg-white/60 backdrop-blur-md rounded-full shadow text-gray-600">
        Workflow
      </p>

      <h3 className="text-3xl md:text-5xl font-extrabold mt-6 mb-4 
      bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
        Built for the Full Flow
      </h3>

      <p className="text-gray-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
        From question generation to results analysis, manage your entire workflow 
        in one intuitive platform.
      </p>
    </div>

   
    <div className="flex justify-center items-center relative">

      <div className="absolute w-[300px] md:w-[400px] h-[300px] md:h-[400px] 
      bg-gradient-to-r from-purple-400 to-blue-400 opacity-20 blur-3xl rounded-full animate-float"></div>

      <img
        src={steps_img}
        alt="Workflow illustration"
        className="relative w-full max-w-md md:max-w-lg lg:max-w-2xl 
        drop-shadow-2xl hover:scale-105 transition duration-500"
      />

    </div>

  </div>
</div>

    
<section className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen py-24 overflow-hidden">

 
  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-full px-6 md:px-12 lg:px-20">

    <div className="flex flex-col lg:flex-row items-center justify-between gap-10 
    bg-white/70 backdrop-blur-lg border border-white/30 
    rounded-2xl px-6 md:px-10 py-10 shadow-md">

      
      <div className="lg:w-8/12 w-full text-center lg:text-left space-y-5">

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight 
        bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
          Ready to build your first Assessment?
        </h1>

        <p className="text-gray-600 text-sm md:text-base leading-relaxed max-w-2xl">
          Launch your first test with ease—powered by AI, built for speed, and flexible enough for any subject, style, or scenario.
          Whether it's a quiz, exam, or survey, building assessments has never been easier—no coding, no confusion, just clear steps and quick setup.
        </p>

      </div>


      <div className="w-full lg:w-auto flex justify-center lg:justify-end">
        <button
          onClick={goToLogin}
          className="w-full sm:w-auto px-10 py-3 text-lg font-semibold rounded-xl 
          text-white bg-gradient-to-l from-indigo-950 to-indigo-800
          shadow-lg hover:scale-105 hover:shadow-xl 
          transition-all duration-300 animate-pulseGlow"
        >
          Start for Free
        </button>
      </div>

    </div>

  </div>
</section>


<div className="relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen py-24 overflow-hidden">


  {/* <div className="absolute top-0 left-0 w-72 h-72 bg-purple-400 opacity-20 blur-3xl rounded-full animate-float"></div>
  <div className="absolute bottom-0 right-0 w-72 h-72 bg-blue-400 opacity-20 blur-3xl rounded-full animate-float2"></div> */}

  <div className="w-full px-6 md:px-12 lg:px-20">

    
    <div className="text-center mb-16">
      <p className="w-fit mx-auto px-6 py-2 text-xs font-semibold 
      bg-white/60 backdrop-blur-md rounded-full shadow text-gray-600">
        FAQ's
      </p>

      <h3 className="text-3xl md:text-5xl font-extrabold mt-6 mb-4 
      bg-gradient-to-l from-indigo-950 to-indigo-800 text-transparent bg-clip-text">
        Frequently Asked Questions
      </h3>

      <p className="text-gray-600 max-w-2xl mx-auto text-sm md:text-base">
        Got questions? We've answered the most common ones to help you get started.
      </p>
    </div>


    <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">


      <div className="lg:col-span-4 space-y-6 text-center lg:text-left">

        <h2 className="text-3xl md:text-4xl font-extrabold leading-snug">
          Happy To Help You <br />
          With{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-l from-indigo-950 to-indigo-800">
            Your Questions
          </span>
        </h2>

        <p className="text-gray-600 text-base leading-relaxed">
          Assessment tools often complicate what should be simple. 
          We've streamlined everything — so you can create, deliver, 
          and analyze assessments without friction or compromise.
        </p>

      </div>

      <div className="lg:col-span-8 space-y-4">

        {faqs.map((faq, index) => (
          <details
            key={index}
            className="group bg-white/70 backdrop-blur-lg border border-white/30 
            rounded-xl shadow-sm hover:shadow-md transition-all duration-300"
          >

            <summary className="px-5 py-4 cursor-pointer font-semibold text-gray-800 
            flex justify-between items-center">

              <span className="group-hover:text-[#36369f] transition">
                {faq.question}
              </span>

              <span className="text-purple-500 group-open:rotate-180 transition">
                ⌄
              </span>

            </summary>

            <p className="px-5 pb-5 text-gray-600 text-sm leading-relaxed">
              {faq.answer}
            </p>

          </details>
        ))}

      </div>

    </div>

  </div>
</div>
</div>
      <TermsAndPolicyFooter />
    </div>
  );
};

export default ProductDetails;